import { IState, Country, State } from 'country-state-city';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translations } from '../../../../../core/models/call-offer';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PhoneNumberFormat } from 'ngx-intl-telephone-input';
import { ActivatedRoute, Router } from '@angular/router';

import {fileTypeExtention,serverError} from './../../../../../core/models/messages';
import { ToastMessage } from './../../../../../core/models/chapitreeval';
import { EsnclientService } from './../../../../../core/services/esnclient/esnclient.service';
import { linkedCompanyRegExp, patternEmail, urlRegExp } from './../../../../../core/models/pattern';
import { CompanyService } from './../../../../../core/services/company/company.service';
@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.css']
})
export class EditClientComponent {
listclients: any;
formclient: FormGroup = this.createclientForm();
SearchCountryField = SearchCountryField;
isDisabled = true;
clientSearchErrorMessage: string | null = null;
client_id: any;
isexistname = false;
id = this.activatedRoute.snapshot.params['id'];
stateList: IState[] = [];
today = new Date();
countries: any = [];
mobilities: any[] = [];
currentDate!: string;
minDate!: string;
 separateDialCode: boolean = false;
CountryISO = CountryISO;
esnDetails:any;
preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
 PhoneNumberFormat = PhoneNumberFormat;
private unsubscribeAll: Subject<void> = new Subject();
//  paysList: any[] = Country.getAllCountries().map((country) => ({
//     ...country,
//     name: this.translateCountryName(country.name),
//   }));
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private clientservice: EsnclientService,
     private spinner: NgxSpinnerService,
     private toastrService: ToastrService,
      private companyService: CompanyService,
       private router : Router
  ) {
      const day = String(this.today.getDate()).padStart(2, "0");
    const month = String(this.today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
    // Set the minimum date to 10 years ago, for example
    const minYear = 1990;
    this.minDate = `${minYear}-${month}-${day}`;
  }
  ngOnInit() {
    this.getEsnById();
    // this.getListclient();
    this.formclient = this.formBuilder.group({
      client_id: ['', Validators.required],
      name: ['', Validators.required],
      linkedin_link: [''],
      website_link: [''],
      country: [''],
      city: [''],
      related_first_name_ESN: [''],
      related_last_name_ESN: [''],
      year_of_creation: [''],
      related_email_ESN: ['', Validators.required],
      related_phone_ESN: [''],
    });
    
  }
    createclientForm(data?: any) {
      return this.formBuilder.group({
        name: [data?.name || '', [Validators.required]],
        related_first_name_ESN: [data?.nom_vis_a_vis || null],
        related_last_name_ESN: [data?.prenom_vis_a_vis || null],
        related_email_ESN: [data?.email_vis_a_vis || null , [ Validators.required, Validators.email, Validators.pattern(patternEmail)]],
        country: [data?.country || null],
         city: [data?.city || []],
        related_phone_ESN: [data?.num_vis_a_vis || null],
        linkedin_link: [data ? data.linkedin_link : "", [Validators.pattern(linkedCompanyRegExp)]],
        website_link: [data ? data.website_link : "", [Validators.pattern(urlRegExp)]],
        // year_of_creation:[data ?new Date(data.year_of_creation).getFullYear().toString() : ''],
        year_of_creation: [data?.year_of_creation || null],
        date_first_presentation: [data?.date_first_presentation || null],
        nb_days: [data?.nb_days || ''],
        client_id: this.id,
      });
    }
    /* get esn details */
  getEsnById() {
    this.spinner.show();
    this.companyService.getCompanydetail(this.id).subscribe({
    
      next: (res: any) => {
        this.esnDetails = res.data[0];
        console.log('this.esnDetails', this.esnDetails);
        this.formclient.patchValue({
          client_id:this.esnDetails.uuid,
            name:   this.esnDetails.name,
            linkedin_link: this.esnDetails.linkedin_link,
            website_link:this.esnDetails.website_link,
            year_of_creation: this.esnDetails.year_of_creation,
            country:this.esnDetails.country,
            city:this.esnDetails.city?.split(',')?.map((item:any)=>item.trim()),
            related_first_name_ESN:this.esnDetails.nom_vis_a_vis,
            related_last_name_ESN:this.esnDetails.prenom_vis_a_vis,
            related_email_ESN:this.esnDetails.email_vis_a_vis,
            related_phone_ESN:this.esnDetails.num_vis_a_vis
          });
        this.spinner.hide();
        console.log('res',res)
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

    

 updateClient() {
   this.formclient.get('related_phone_ESN')?.setValue(this.formclient.get('related_phone_ESN')?.value?.internationalNumber);
         console.log('related_phone_ESN',this.formclient.get('related_phone_ESN')?.setValue(this.formclient.get('related_phone_ESN')?.value?.internationalNumber));
        // console.log('formclient',this.formclient.value)
          let date: any = new Date(this.formclient.get('year_of_creation')?.value);
          let yearOfCreation = date?.getFullYear();
          console.log('this.formclient',this.formclient.value.country)
          this.formclient.patchValue({
              client_id: this.id,
              related_first_name_ESN: this.formclient.value.related_first_name_ESN,
              related_email_ESN: this.formclient.value.related_email_ESN,
              related_last_name_ESN: this.formclient.value.related_last_name_ESN,
              related_phone_ESN: this.formclient.value?.related_phone_ESN?.number,
              date_first_presentation: this.formclient.value.date_first_presentation,
              country:this.formclient.value.country,
              nb_days: this.formclient.value.nb_days,
              year_of_creation: this.formclient.value.year_of_creation 
          });
        this.clientservice.updateClient(this.formclient.value).subscribe({
          next: (res: any) => {
            this.toastrService.success('Mail modifier avec succès.');
              // this.getListclient();
              this.router.navigate([`/nos-clients/liste`]);
          },
          error: () => {
            this.toastrService.error(serverError);
          },
        });
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9\/]/g, '');
  }
  toastMessages: ToastMessage = {
      success: 'Client ajouté avec succès',
      error: 'Client avec ce nom existe déjà',
    };
}
